module.exports = __webpack_public_path__ + "img/grinning-cat-with-smiling-eyes.83dbbe8b.png";